import { AnyFormElement } from '../forms-ui-form-faas.interface';
import { IConsentService } from './consent-service';

export interface IFormValidator {
  isFormValid(fieldRefs: AnyFormElement[]): Promise<boolean>
}

export class FormValidator implements IFormValidator {
	private consentService: IConsentService;

	constructor(consentService: IConsentService) {
		this.consentService = consentService;
	}

	async isFormValid(fieldRefs: AnyFormElement[]): Promise<boolean> {
		await this.validateFields(fieldRefs);
		const areConsentsValid = this.consentService.validateConsents();
		return !fieldRefs.some((ref) => ref.error) && areConsentsValid;
	}

	/** validate form fields */
	async validateFields(fieldRefs: AnyFormElement[]) {
		await Promise.all(fieldRefs.map(async (ref) => {
			await ref.validate();
		}));
	}
}

export const createFormValidator = (consentService: IConsentService)
	: IFormValidator => new FormValidator(consentService);
